import { applyMiddleware, combineReducers, createStore } from 'redux';
import thunk from 'redux-thunk';
import register from '../store/reducers/register.reducer';
import auth from '../store/reducers/auth.reducer';
import app from "../store/reducers/app.reducer";

const appReducer = combineReducers({
  register,
  auth,
  app
});

const rootReducer = (state, action) => {
  return appReducer(state, action);
};

const store = createStore(rootReducer, applyMiddleware(thunk));
export default store;
